import { render } from "./GoogleMyBusiness.vue?vue&type=template&id=2296a1c6"
import script from "./GoogleMyBusiness.vue?vue&type=script&lang=js"
export * from "./GoogleMyBusiness.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__